<form class="form-group" #f (click)="onChange(f)">
  <div class="form-group">
    <label class="control-label" for="firstName">First Name</label>
    <input class="form-control"
           type="text"
           required
           max="255"
           maxlength="255"
           minlength="3"
           name="firstName"
           ngModel
           #firstName="ngModel"
           (change)="onChange(firstName)"
           id="firstName">
    <validation-message [model]="firstName">

    </validation-message>

  </div>
  <div class="form-group">
    <label class="control-label" for="comment">Comment</label>
    <textarea class="form-control"
              id="comment"
              name="comment"
              cols="30"
              rows="10"></textarea>
  </div>

  <div class="form-group">
    <input type="submit" value="Submit" class="btn btn-primary" />
    <input type="reset" value="Reset" class="btn btn-danger pull-right" />
  </div>
</form>



